import { BaseService } from 'hungry-core2'

import actions from '@actions'

type ConsumptionBypassResult = { confirmed: true; reason: string }

export default class ConsumptionBypassModal extends BaseService {
  private resolve: ((value: ConsumptionBypassResult | null) => void) | undefined

  close = (): void => {
    this.dispatch(actions.closeConsumptionBypassModal())
    this.resolve && this.resolve(null)
    delete this.resolve
  }

  confirm = (reason: string): void => {
    this.dispatch(actions.closeConsumptionBypassModal())
    this.resolve && this.resolve({ confirmed: true, reason })
    delete this.resolve
  }

  show = ({
    title,
  }: {
    title?: string
  }): Promise<ConsumptionBypassResult | null> => {
    return new Promise((resolve) => {
      this.resolve = resolve
      this.dispatch(actions.showConsumptionBypassModal({ title }))
    })
  }
}
